export default "__VITE_PUBLIC_ASSET__44b1c355__"